import React from "react";
import { Box, Grid, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import MyRideCard from "./MyRideCard";
import ReserveRide from "./ReserveRide";
import Loader from "components/loader/Loader";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";

function MyRideTab(props) {
  const loader = props?.loader;
  return (
    <Grid container justifyContent="flex-start">
      <Grid item className="tableContainer" xs={12}>
        <Box className="contentBoxStyle boxMargin">
          <TabContext value={props?.value}>
            <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <TabList
                  className="minHeight32"
                  onChange={props?.handleChange}
                  aria-label="lab API tabs example"
                  xs={6}
                  TabIndicatorProps={{
                    style: { display: "none" },
                  }}
				  
                >
                  <Tab label="All" value="All" className="tabStyleOne" />
                  <Tab
                    label="Upcoming"
                    value="upcoming"
                    className="tabStyleOne"
                  />
                  <Tab
                    label="Completed"
                    value="completed"
                    className="tabStyleOne"
                  />
                  <Tab
                    label="Cancelled"
                    value="cancelled"
                    className="tabStyleOne"
                  />
                </TabList>
              </Grid>
            </Grid>
            <TabPanel value="All" className="tabPanelStyle">
              {loader ? (
                <Loader />
              ) : props?.tripData?.length > 0 ? (
                <Grid ite xs={12}> 
                  <ReserveRide />
                  <MyRideCard
                    tripData={props?.tripData}
                    page={props?.page}
                    totalCount={props?.totalCount}
                    handleClick={props?.handleClick}
                    handleChangePage={props?.handleChangePage}
                    handleChangeRowsPerPage={props?.handleChangeRowsPerPage}
                    rowsPerPage={props?.rowsPerPage}
                  />
                </Grid>
              ) : (
                <CommonNoDataFound />
              )}
            </TabPanel>
            <TabPanel value="upcoming" className="tabPanelStyle">
              {loader ? (
                <Loader />
              ) :  props?.tripData?.length > 0 ? (
                <Grid item>
                 { props?.tripData?.length === 0 
                 ? 
                 <ReserveRide />
                 :
                  <MyRideCard 
                    tripData={props?.tripData}
                    page={props?.page}
                    handleClick={props?.handleClick}
                    totalCount={props?.totalCount}
                    handleChangePage={props?.handleChangePage}
                    handleChangeRowsPerPage={props?.handleChangeRowsPerPage}
                    rowsPerPage={props?.rowsPerPage}
                  />}
                </Grid>
              ): <CommonNoDataFound />}
            </TabPanel>
            <TabPanel value="completed" className="tabPanelStyle">
              {loader ? (
                <Loader />
              ) :  props?.tripData?.length > 0 ? (
                <Grid item>
                  <MyRideCard
                    tripData={props?.tripData}
                    page={props?.page}
                    handleClick={props?.handleClick}
                    totalCount={props?.totalCount}
                    handleChangePage={props?.handleChangePage}
                    handleChangeRowsPerPage={props?.handleChangeRowsPerPage}
                    rowsPerPage={props?.rowsPerPage}
                  />
                </Grid>
              ) : <CommonNoDataFound/> }
            </TabPanel>
            <TabPanel value="cancelled" className="tabPanelStyle">
              {loader ? (
                <Loader />
              ) : props?.tripData?.length > 0 ?  (
                <Grid item>
                  <MyRideCard
                    tripData={props?.tripData}
                    page={props?.page}
                    handleClick={props?.handleClick}
                    totalCount={props?.totalCount}
                    handleChangePage={props?.handleChangePage}
                    handleChangeRowsPerPage={props?.handleChangeRowsPerPage}
                    rowsPerPage={props?.rowsPerPage}
                  />
                </Grid>
              ) :<CommonNoDataFound />}
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}

export default MyRideTab;
